import { FaSearch } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import styles from './styles/GroupOne.module.css'

export default function GroupOne({ userisloged }) {
  return (
    <div className={styles.group_one}>
      <div className={styles.input_segment}>
        <Link to='/'><img src='./elaele.png' alt='site icon' /></Link>
        <input type='text' placeholder='Buscar por...' />
        <FaSearch />
      </div>
      
    </div>
  )
}